import React, { useState } from "react";
// import * as Components from "../all";
import { IoIosSearch } from "react-icons/io";
import { CgMenuGridO } from "react-icons/cg";
import { IoCloseCircleOutline, IoCloseSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { BiLink } from "react-icons/bi";

export default function Navbar({ showSidebar, setShowSidebar }) {
	const navigate = useNavigate();
	const links = [
		{
			name: "Dashboard",
			link: "dashboard",
		},
		{
			name: "Revenue",
			link: "revenue",
		},
		{
			name: "Parking Space Revenue",
			link: "revenue/ps",
		},
		{
			name: "Trends",
			link: "trends",
		},
		{
			name: "Parking Space Trends",
			link: "trends/ps",
		},
		{
			name: "Users",
			link: "users",
		},
		{
			name: "User Details",
			link: "users",
		},
		{
			name: "Parking Spaces",
			link: "parkingspaces",
		},
		{
			name: "Parking Space Details",
			link: "parkingspaces",
		},
		{
			name: "Create New Parking space",
			link: "parkingspaces/newps",
		},
		{
			name: "Admins",
			link: "admins",
		},
		{
			name: "Create New Admin",
			link: "admins",
		},
		{
			name: "Reset Admin Password",
			link: "admins",
		},
		{
			name: "Change Admin Status",
			link: "admins",
		},
		{
			name: "Customer Support",
			link: "customersupport",
		},
		{
			name: "Create New Agent",
			link: "customersupport",
		},
		{
			name: "Change Agent Status",
			link: "customersupport",
		},
		{
			name: "Reset Agent Password",
			link: "customersupport",
		},
		{
			name: "Packages",
			link: "packages",
		},
		{
			name: "Package Details",
			link: "packages",
		},
		{
			name: "Create New Package",
			link: "packages/newps",
		},
		{
			name: "Parking Rates",
			link: "packages",
		},
	];

	const [showLinks, setShowLinks] = useState(false);
	const [filteredUsers, setFilteredUsers] = useState([]);
	const search = (term) => {
		if (term === "") {
			setShowLinks(false);
			setFilteredUsers([]);
			return;
		}

		const filtered = links.filter(
			(x) => x.name.toLowerCase().indexOf(term.toLowerCase()) > -1
		);
		setFilteredUsers(filtered);
		setShowLinks(true);
	};

	return (
		<div
			style={{
				boxShadow: "0px 0px 6px rgb(20 20 20 / 0.1)",
			}}
			className="Navbar
            h-[50px]
            bg-white
            flex items-center
			z-10
            "
		>
			{/* Logo */}
			<div
				className="
				px-4
				min-w-[230px] w-full sm:w-[15%]
				flex items-center justify-between
				"
			>
				<h1 className="font-bold text-xl text-main">Air Space</h1>

				{/* menu button */}
				<div className="lg11:hidden">
					{showSidebar === true ? (
						<IoCloseSharp
							className="text-main cursor-pointer"
							size={20}
							onClick={() => setShowSidebar(false)}
						/>
					) : (
						<CgMenuGridO
							className="text-main cursor-pointer"
							size={20}
							onClick={() => setShowSidebar(true)}
						/>
					)}
				</div>
			</div>

			{/* Admin Area */}
			<h1
				className="
				text-sm 
				uppercase 
				font-bold text-dark
				max-sm:hidden
				"
			>
				Super Admin Portal
			</h1>

			{/* Search */}
			<div
				className="
				ml-10 
				px-2 py-1
				flex-1
				flex items-center
				border-l-2
				max-lg:hidden
				relative
				"
			>
				<IoIosSearch color="#707070a8" size={18} />
				<input
					type="text"
					placeholder="Search anything ..."
					className="w-[50%]
					bg-transparent 
					px-2 
					text-sm
					focus:outline-none
					font-medium
					text-dark
					"
					onChange={(e) => search(e.target.value)}
				/>

				{showLinks === true && (
					<div
						className="absolute 
						flex flex-col 
						top-full left-0
						max-h-[350px]
						w-[700px] 
						py-5 px-6 mt-4 bg-white
						rounded-md border shadow-xl
						overflow-auto
						"
						onBlur={() => setShowLinks(false)}
					>
						<div className="flex items-center mb-3">
							<div
								className="h-6 aspect-square
							 	bg-bg1 
								text-main
								rounded-full
								flex items-center justify-center
								text-base
								mr-2
								"
							>
								<BiLink />
							</div>

							<h1 className="text-darker uppercase tracking-wide">Links</h1>

							<button className="text-red-400 ml-auto hover:opacity-50"
							onClick={()=>setShowLinks(false)}
							>
								<IoCloseCircleOutline size={20} />
							</button>
						</div>

						{filteredUsers.map(({ name, link }) => (
							<div
								className="
								text-darker font-medium
								my-1.5 px-4 py-2.5 
								rounded border 
								cursor-pointer
								duration-500 ease-in-out
								shadow-sm hover:shadow-md
								"
								onClick={() => {
									setShowLinks(false);
									navigate(link);
								}}
							>
								{name}
							</div>
						))}
					</div>
				)}
			</div>

			{/* Profile */}
			<button
				className="
				rounded-md
				overflow-hidden
				px-3 py-1 mr-4 max-lg:ml-auto
				text-sm 3xl:text-base font-medium
				border
				text-main
				duration-300 ease-in-out
				hover:opacity-70
				max-sm:hidden
				"
				onClick={() => setShowSidebar(false)}
			>
				Admin profile
			</button>
		</div>
	);
}
